import React from 'react';

import CaretDownIcon from '../assets/icons/caret-down.svg';
import ChatIcon from '../assets/chat-icon.svg';

export interface HeaderProps {
  collapsible: boolean;
  onClickMinimize: () => void;
}

function Header({ collapsible, onClickMinimize }: HeaderProps): JSX.Element {
  return (
    <header className="App-header">
      <div className="Header-content">
        <img className="Header-icon" src={ChatIcon} alt="" />
        <h1>ALEX Chat</h1>
      </div>
      {collapsible && (
        <button
          className="Minimize-button"
          onClick={onClickMinimize}
          type="button"
          data-testid="minimize-button"
          aria-label="minimize chat"
        >
          <img src={CaretDownIcon} alt="collapse" />
        </button>
      )}
    </header>
  );
}

export default Header;
